export default "__VITE_ASSET__d9533bb1__"